module.exports = __webpack_public_path__ + "img/areas.ab9dfdbc.svg";